import { useQuery } from "@apollo/client/react";
import { Box, Loading, Notification } from "orcs-design-system";

import type { ParsedInboxKey } from "../kinds";
import { RequisitionInboxDetail } from "./Detail";
import { inboxRequisitionLookup } from "./lookup.graphql";
import type { InboxRequisition } from "./item";

type LookupQuery = {
  result?: { requisitions?: InboxRequisition[] | null } | null;
};

const RequisitionMissing = ({ parsed }: { parsed: ParsedInboxKey }) => {
  const lookup = useQuery<LookupQuery>(inboxRequisitionLookup, {
    variables: {
      searchTerms: [parsed.subjectId],
      size: 20,
    },
  });
  const found =
    lookup.dataState === "complete"
      ? (lookup.data.result?.requisitions?.find(
          (row) => row.id === parsed.subjectId
        ) ?? null)
      : null;
  if (lookup.loading) {
    return <Loading />;
  }
  if (lookup.error || lookup.dataState !== "complete") {
    return (
      <Box p="r">
        <Notification variant="error" closable={false}>
          This requisition could not be loaded.
        </Notification>
      </Box>
    );
  }
  if (!found) {
    return (
      <Box p="r">
        <Notification variant="warning" closable={false}>
          This no longer needs your action
        </Notification>
      </Box>
    );
  }
  const item =
    parsed.kind === "REQUISITION_APPROVAL"
      ? {
          title:
            found.role?.trim() || found.externalId?.trim() || parsed.subjectId,
          kind: parsed.kind,
          approverGroupId: parsed.qualifier,
        }
      : {
          title:
            found.role?.trim() || found.externalId?.trim() || parsed.subjectId,
          kind: parsed.kind,
        };
  return <RequisitionInboxDetail item={item} requisition={found} readOnly />;
};

export default RequisitionMissing;
